import React from 'react';
import { getState, subscribe, useStoreSelector } from './firebaseState';

export const Provider = ({ children }) => <>{children}</>;

export const useSelector = selector => useStoreSelector(selector);

export const connect = (mapStateToProps, mapDispatchToProps) => Component => {
  const ConnectedComponent = props => {
    const mappedState = useStoreSelector(state => {
      if (typeof mapStateToProps !== 'function') return {};
      return mapStateToProps(state, props) || {};
    }, [props]);

    const mappedDispatch = React.useMemo(() => {
      if (typeof mapDispatchToProps === 'function') {
        return mapDispatchToProps(() => {}, () => getState(), props) || {};
      }
      return mapDispatchToProps || {};
    }, [props]);

    return <Component {...props} {...mappedState} {...mappedDispatch} />;
  };

  ConnectedComponent.displayName = `connect(${Component.displayName || Component.name || 'Component'})`;
  return ConnectedComponent;
};

export { subscribe };
